import { TabGroup } from '@/components/Tabs/Tabs';
import { TabLabel, TabList } from '@/design-system/components/Tabs';

import { useDatasetTemplateStore } from '../hooks/useDatasetTemplateStore';

export function DatasetTabs() {
  const setTemplate = useDatasetTemplateStore((state) => state.setTemplate);
  const template = useDatasetTemplateStore((state) => state.template);

  const selectedIndex = template === 'file' ? 0 : 1;
  return (
    <TabGroup
      setTabMethod="none"
      defaultIndex={selectedIndex}
      prefix="dataset-upload-type"
      onChange={(index) => {
        const tab = index === 0 ? 'file' : 'scratch';
        setTemplate(tab);
      }}
    >
      <TabList>
        <TabLabel label="Create from file" />
        <TabLabel label="Create from scratch" />
      </TabList>
    </TabGroup>
  );
}
